<template>
  <div class="header">
    <div class="header-title">
      <span class="header-title-text" :data-text="getTitle">{{ getTitle }}</span>
      <span class="header-title-icon header-title-rule" @click="showRuleDialog"></span>
      <span class="header-title-icon header-title-history" @click="showHistoryDialog"></span>
    </div>
    <div class="header-userinfo">
      <div class="header-userinfo-diamond">
        <span class="diamond"></span>
        <span>{{ $bus.gems }}</span>
      </div>
      <div class="header-userinfo-uid">
        ID:{{ $bus.uid }}
      </div>
    </div>
  </div>
</template>

<script>
import { addGA } from '@/utils/assist'

export default {
  computed: {
    getTitle () {
      return this.$bus.transify['FESTA_TITLE']
    }
  },
  methods: {
    showRuleDialog () {
      addGA('show-rule-dialog', 'click')
      if (this.$bus.isFirst) {
        return
      }
      this.$bus.ruleDialogShow = true
    },
    showHistoryDialog () {
      addGA('show-history-dialog', 'click')
      if (this.$bus.isFirst) {
        return
      }

      // request history
      this.$api.history().then(res => {
        this.$bus.historyDialogList = this.$bus.mergeList(res.data, 'pk')
        this.$bus.historyDialogShow = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  @include flexrc;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  @include px2res(height, 62);

  .header-title {
    display: flex;
    align-items: center;

    .header-title-text {
      position: relative;
      @include px2res(font-size, 42);
      /* color: $orange; */
      font-family: $main-font-family;
      font-style: italic;
      /* @include px2res(-webkit-text-stroke-width, 2); */
      /* -webkit-text-stroke-color: $yellow; */

      /* &::after {
        content: attr(data-text);
        position: absolute;
        left: 0;
        z-index: -2;
        @include px2res(-webkit-text-stroke-width, 4);
        -webkit-text-stroke-color: $green;
        font-family: $main-font-family;
      } */
      color: #fff;
      filter: drop-shadow(1px 0px 0px #4a250f) drop-shadow(-1px 0px 0px #4a250f)
        drop-shadow(0px 1px 0px #4a250f) drop-shadow(0px -1px 0px #4a250f)
        drop-shadow(1px 0px 0px #0b5b9e) drop-shadow(-1px 0px 0px #0b5b9e)
        drop-shadow(0px 1px 0px #0b5b9e) drop-shadow(0px -1px 0px #0b5b9e);
    }

    .header-title-icon {
      @include px2res(width, 34);
      @include px2res(height, 34);
    }

    .header-title-rule {
      @include px2res(margin-left, 16);
    }

    .header-title-history {
      @include px2res(margin-left, 12);
    }
  }

  .header-userinfo {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    @include px2res(right, 56);

    .header-userinfo-diamond {
      @include flexac;
      @include px2res(font-size, 36);

      .diamond {
        @include px2res(width, 30);
        @include px2res(height, 27);
        @include px2res(margin-right, 8);
      }
    }

    .header-userinfo-uid {
      @include px2res(padding-left, 38);
      @include px2res(font-size, 20);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue